module.exports = __webpack_public_path__ + "img/img23.106a31ed.svg";